import React, { Fragment, useState, useRef } from "react";
import useLocalStorage from "../../hooks/useLocalStorage";
import { H6, Image } from "../../AbstractElements";
import { Settings } from "react-feather";
import AvatarUser from "../../Components/EditUser/AvatarUser";
import { Tag } from "primereact/tag";
import { Avatar } from "primereact/avatar";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { RESET_PASSWORD } from "Constant";
import ResetPassword from "./ResetPassword";
import { Toast } from "primereact/toast"; // Import Toast

const Profile = () => {
  const { getData } = useLocalStorage();
  const userData = getData("userData");
  const [isOpen, setIsopen] = useState(false);
  const toastRef = useRef(null); // Toast reference

  const toggleModal = () => {
    setIsopen((prevState) => !prevState);
  };

  const currentUser = userData
    ? {
        fullName: `${userData?.firstname} ${userData?.lastname}`,
        img: userData.img ?? userData.image,
        role: userData.phone ?? userData.role,
      }
    : {
        fullName: "",
        img: "",
        role: "",
      };

  return (
    <Fragment>
      {/* Global Toast */}
      <Toast ref={toastRef} position="top-right" />

      <div className="sidebar-user text-center">
        <div className="setting-primary" onClick={toggleModal}>
          <Settings />
        </div>
        {currentUser.img ? (
          <>
            <Image
              attrImage={{
                className: "img-100 rounded-circle",
                src: currentUser.img,
                alt: "",
              }}
            />
            <div className="badge-bottom">
              <Tag value={currentUser.role} severity="" />
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                marginLeft: "65px",
                marginBottom: "0px",
              }}
            >
              <AvatarUser image={currentUser.img} />
            </div>
            <div
              className="badge badge-primary"
              style={{
                color: "white",
                marginLeft: "0px",
                marginTop: "0px",
              }}
            >
              {currentUser.role}
            </div>
          </>
        )}
        <H6
          attrH6={{
            className: "mt-3 f-14 f-w-600",
          }}
        >
          {currentUser.fullName}
        </H6>
      </div>
      <Modal
        isOpen={isOpen}
        toggle={toggleModal}
        size="sm"
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={toggleModal}>{RESET_PASSWORD}</ModalHeader>
        <ModalBody>
          {/* Pass the Toast reference to ResetPassword */}
          <ResetPassword onCancel={toggleModal} toastRef={toastRef} />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default Profile;
